import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useState } from 'react';
import TruncateMarkup from 'react-truncate-markup';
import { propStr } from '../../../../../../../helpers/custom-prop-types';
import { useBoolState } from '../../../../../../../helpers/use/useHook';
import ProffitSearchFolderShareCommentModal from '../ShareCommentModal';
const ProffitSearchFolderShareCommentContent = (props) => {
    const { className, content } = props;
    const [isTruncated, changeIsTruncated] = useState(false);
    const { boolState: isShowModal, changeFalse: hideModal, changeTrue: showModal, } = useBoolState(false);
    return (_jsx("div", Object.assign({ className: clsx('proffit_search_folder_share_comment_content', className) }, { children: _jsxs("div", Object.assign({ className: 'content_inner' }, { children: [content && (_jsx(TruncateMarkup, Object.assign({ lines: 2, onTruncate: changeIsTruncated }, { children: _jsx("div", Object.assign({ className: 'content_text' }, { children: content })) }))), content && isTruncated && (_jsxs(_Fragment, { children: [_jsx("button", Object.assign({ className: 'content_button', onClick: showModal, type: 'button' }, { children: "\u7D9A\u304D\u3092\u8AAD\u3080" })), _jsx(ProffitSearchFolderShareCommentModal, { className: 'full_screen_proffit_search_folder_share_comment_modal', content: content, hideFullModal: hideModal, isShow: isShowModal })] }))] })) })));
};
ProffitSearchFolderShareCommentContent.propTypes = {
    className: propStr(),
    content: propStr().isRequired,
};
ProffitSearchFolderShareCommentContent.defaultProps = {
    className: '',
};
export default ProffitSearchFolderShareCommentContent;
